// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueLazyload from 'vue-lazyload'
import vuescroll from 'vuescroll'
import 'vuescroll/dist/vuescroll.css'

// Vue resource to do http requests
Vue.use(VueResource)
// Defining root url for requests
// Vue.http.options.root = 'http://dev.vuesite.fmixlab.com/wp-json/'
Vue.http.options.root = 'https://vuesiteadmin.fmixlab.com/wp-json/'

// Vue lazyload to lazyload images in project details
Vue.use(VueLazyload)

// Vue vuescroll for a nicer scroll bar
Vue.use(vuescroll)

// VUe config
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js